import {DataViewWrapperInterface} from "../Interfaces/DataViewWrapperInterface";
import {DataViewInterface} from "../Interfaces/DataViewInterface";
import {DataTypesEnum} from "../enums/dataTypesEnum";
import {DataView} from "./DataView";

export class DataViewWrapper implements DataViewWrapperInterface {
    private readonly dictionary: Map<number, DataViewInterface> = new Map();

    constructor(dataViews: DataViewInterface[]) {
        this.addDataViews(dataViews);
    }

    addDataView(dataView: DataViewInterface): void {
        this.dictionary.set(dataView.id, new DataView(dataView.id, dataView.viewName, dataView.businessObjectClass, columnsGenerator(dataView.columns), dataView.isActive, dataView.isDefault));
    }

    addDataViews(dataViews: DataViewInterface[]): void {
        dataViews.forEach(dataView => {
            this.dictionary.set(dataView.id, new DataView(dataView.id, dataView.viewName, dataView.businessObjectClass, columnsGenerator(dataView.columns), dataView.isActive, dataView.isDefault))
        })
    }

    deleteDataView(id: number): void {
        this.dictionary.delete(id);
    }

    updateDataView(dataView): void {
        const dView = this.dictionary.get(dataView.id);
        dView.isDefault = dataView.isDefault;
        dView.isActive = dataView.isActive;
        dView.viewName = dataView.viewName;
    }

    getDataView(id: number): DataViewInterface {
        return this.dictionary.get(id);
    }

    getDataViews(arg: string): DataViewInterface[] | Map<number, DataViewInterface> {
        switch (arg) {
            case DataTypesEnum.ARRAY: {
                return Array.from(this.dictionary.values());
            }
            case DataTypesEnum.MAP: {
                return this.dictionary;
            }
        }
    }

    hasDataView(arg: number): boolean {
        switch (typeof arg) {
            case "number": {
                return this.dictionary.has(arg);
            }
        }
    }

    getDefaultDataViewByBocId(id: number): DataViewInterface {
        const dataViewsArray = Array.from(this.dictionary.values());
        for (let i = 0; i < dataViewsArray.length; i++) {
            const dataView = dataViewsArray[i];
            if (dataView.businessObjectClass.id === id && dataView.isDefault) {
                return dataView;
            }
        }
    }

    checkDataViewBeforeSave(dataview: DataView): { valid: boolean; msg: string } {
        const result = dataview.isValid();
        if (!result.valid) {
            return result;
        }
        const dataViewsArray = <DataView[]>this.getDataViews(DataTypesEnum.ARRAY);
        for (let i = 0; i < dataViewsArray.length; i++) {
            const dv = dataViewsArray[i];
            if (dataview.businessObjectClass.id === dv.businessObjectClass.id && dataview.id != dv.id) {
                if (dataview.viewName === dv.viewName) {
                    return {valid: false, msg: "The dataview with this name already exists."}
                }
            }
        }
        return {valid: true, msg: ""};
    }

    getDataViewsByBocId(id: number): DataView[] {
        const dataViewsArray = <DataView[]>this.getDataViews(DataTypesEnum.ARRAY);
        const dataViews = [];
        dataViewsArray.forEach(dataView => {
            if (dataView.businessObjectClass.id === id) {
                dataViews.push(dataView)
            }
        });
        return dataViews
    }

    setDefaultDataViewByBocId(id: number, viewName: string): void {
        const dataViews = <DataView[]>this.getDataViews(DataTypesEnum.ARRAY);
        for (let i = 0; i < dataViews.length; i++) {
            if (dataViews[i].businessObjectClass.id === id) {
                dataViews[i].isDefault = dataViews[i].viewName === viewName;
            }
        }
    }

    getFullDataViewByBocId(id: number): DataView {
        const dataViews = <DataView[]>this.getDataViews(DataTypesEnum.ARRAY);
        for (let i = 0; i < dataViews.length; i++) {
            if (dataViews[i].businessObjectClass.id === id && dataViews[i].viewName === "full") {
                return dataViews[i];
            }
        }
    }
}

const columnsGenerator = (cols) => {
    return cols.map(column => {
        return {
            id: column['value'] ? column['value'].id : null,
            columnOrder: column['columnOrder'],
            type: column['type'],
            value: column['value'] ? column['value'] : {id: null, name: "Tags"}
        };
    });
};



// WEBPACK FOOTER //
// ./app/components/bo-core/models/DataViewWrapper.ts